import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } },
        );
        // Clear the hash and hard-reload to restart AuthProvider with the new session
        window.history.replaceState(null, "", "/");
        window.location.replace("/");
        // As a fallback for jsdom / older browsers
        return res;
      } catch (e) {
        const detail = e?.response?.data?.detail || "Sign-in failed. Try again.";
        setError(detail);
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#F5F4F0] flex items-center justify-center" data-testid="auth-loading">
      <div className="bg-white border-2 border-[#1F1E1B] p-8 shadow-[8px_8px_0_0_#1F1E1B] max-w-md w-full mx-4">
        {error ? (
          <div className="space-y-4">
            <div className="font-display text-2xl font-black text-[#BC4727]">Sign-in failed</div>
            <div className="text-sm text-[#66645E]">{error}</div>
            <button
              onClick={() => navigate("/login", { replace: true })}
              className="bg-[#1A4135] text-white px-5 py-2 text-sm font-bold uppercase tracking-wider"
              data-testid="auth-error-back-btn"
            >
              Back to sign-in
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-3 text-[#1F1E1B]">
            <Loader2 className="w-5 h-5 animate-spin" />
            <div>
              <div className="font-display text-xl font-black">Signing you in…</div>
              <div className="text-xs text-[#66645E]">Wiring up your session, hold tight.</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
